import React from "react";
import RatingsReviews from "./RatingAndReviews";


const ProductSections = () => {
  const productDetails = {
    description:
      "This saree is woven with fine silk and intricate craftsmanship, showcasing the rich heritage of handloom weaving.",
    fabric: "Pure Tussar Silk",
    weaving: "Handwoven",
    art: "Temple Kumbha Design",
  };
  
  const ratings = [
    { user: "Aditi S.", rating: 5, review: "Absolutely love the fabric and craftsmanship!" },
    { user: "Neha K.", rating: 4, review: "Beautiful saree, but delivery took time." },
    { user: "Riya J.", rating: 5, review: "Worth every penny, stunning piece!" },
  ];
  
  const exclusiveness = [
    { title: "Rare Handwoven Art", image: "https://via.placeholder.com/300", description: "This saree features an exclusive handwoven design found only in limited regions." },
    { title: "Premium Tussar Silk", image: "https://via.placeholder.com/300", description: "Crafted from the finest Tussar silk, offering luxury and comfort." },
  ];
  
  const recommendedProducts = [
    { name: "Banarasi Silk Saree", price: "₹9,500", image: "https://via.placeholder.com/200" },
    { name: "Kanjivaram Silk Saree", price: "₹12,000", image: "https://via.placeholder.com/200" },
    { name: "Chanderi Cotton Saree", price: "₹7,800", image: "https://via.placeholder.com/200" },
    { name: "Patola Silk Saree", price: "₹15,000", image: "https://via.placeholder.com/200" },
  ];
  
  return (
    <div className="max-w-7xl mx-auto p-6 space-y-12">
      {/* Product Details Section */}
      <section className="bg-gray-100 p-6 rounded-xl shadow-md">
        <h2 className="text-2xl font-semibold mb-4">Product Details</h2>
        <p>{productDetails.description}</p>
        <ul className="mt-4 space-y-2">
          <li><strong>Fabric:</strong> {productDetails.fabric}</li>
          <li><strong>Weaving:</strong> {productDetails.weaving}</li>
          <li><strong>Art:</strong> {productDetails.art}</li>
        </ul>
      </section>

      {/* Ratings & Reviews Section */}
      <RatingsReviews/>
      {/* <section className="p-6 rounded-xl shadow-md border">
        <h2 className="text-2xl font-semibold mb-4">Ratings & Reviews</h2>
        <div className="space-y-4">
          {ratings.map((item, index) => (
            <div key={index} className="bg-white p-4 rounded-lg shadow-md">
              <p className="font-semibold">{item.user}</p>
              <p className="text-yellow-500">{'★'.repeat(item.rating)}{'☆'.repeat(5 - item.rating)}</p>
              <p>{item.review}</p>
            </div>
          ))}
        </div>
      </section> */}

      {/* Product Exclusiveness Section */}
      <section className="p-6 rounded-xl shadow-md border">
        <h2 className="text-2xl font-semibold mb-4">Exclusive Features</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {exclusiveness.map((item, index) => (
            <div key={index} className="flex flex-col items-center text-center bg-gray-100 p-4 rounded-lg">
              <img src={item.image} alt={item.title} className="w-48 h-48 object-cover rounded-md mb-3" />
              <h3 className="text-xl font-semibold">{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Recommended Products Section */}
      <section className="p-6 rounded-xl shadow-md border">
        <h2 className="text-2xl font-semibold mb-4">Recommended Products</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {recommendedProducts.map((product, index) => (
            <div key={index} className="bg-white p-4 rounded-lg shadow-md text-center">
              <img src={product.image} alt={product.name} className="w-full h-40 object-cover mb-2 rounded-md" />
              <p className="font-semibold">{product.name}</p>
              <p className="text-pink-600 font-bold">{product.price}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ProductSections;